/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { AssessmentContext } from 'app/core/lib/assessment-context';
import { IQuestionComponent, IQuestionConfig } from 'app/core/components/assessments/interfaces';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { FormatProvider } from 'app/shared/lib/formatting/format-provider';
import { QuestionBase } from 'app/core/components/assessments/questions/question-base';
import * as Core from 'app/core/models/essette-api';
import { isNullOrUndefined } from 'app/shared/lib/utilities';


@autoinject
export class QuestionNumberCustomElement extends QuestionBase implements IQuestionComponent {

    ////****************** Fields and Properties **************************************////

    protected answerValue: number | null = null;
    protected history: Core.AssessmentAnswer[] = [];
    protected isNullOrUndefined = isNullOrUndefined;
    public labelId: string | null = null;

    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(
        protected readonly context: AssessmentContext,
        private readonly formatProvider: FormatProvider,
        private readonly logger: AppLogger) {

        super(context);
        this.logger.source = this;

        if(!context || !context.currentSession) {
            throw new Error("No Assessment context is available");
        }

        if(!this.context.questionComponents.includes(this)) {
            this.context.questionComponents.push(this);
        }
    }

    protected async activate(config: IQuestionConfig): Promise<void> {
        this.question = config.question;
        this.required = !!this.question.flag?.isRequired;
        this.showHistory = config.showHistory;
        this.readonly = config.readonly;
        this.isValid = !this.required;
        this.labelId = config.labelId;
    }

    protected attached(): void {
        this.loadPreviousAnswer();

        if(this.showHistory && this.context && this.context.attachment && this.context.attachment.history && this.context.attachment.history.answers) {
            this.history = this.context.attachment.history.answers.filter(a => { return a.question!.id === this.question!.id; });
        }
    }


    ////****************** Events ***********************************************////


    ////****************** Functions ****************************************************////
    private async loadPreviousAnswer(): Promise<void> {
        const questionId = this.question && this.question.id;
        if(!questionId || !this.context.attachment.currentAnswers) { return; }

        const description = this.question && this.question.description || '';

        try {
            const answer = this.context.attachment.currentAnswers.find(a => {
                if(!a.question) { return false; }

                if(!this.question.sharedQuestion) {
                    return a.question.id === this.question.id;
                } else if(!!this.question.sharedQuestion && !!a.sharedQuestion) {
                    return this.question.sharedQuestion.id === a.sharedQuestion.id;
                }

                return false;

            });

            if(answer) {
                this.answerValue = this.formatProvider.parseNumber(answer.value || null);
            }
        }
        catch(error) {
            this.logger.error(`Find existing answer error: ${error}`);
            this.logger.error(`Unable to find existing answer(s) for question ${questionId} (${description})`);
            throw error;
        }
    }


    ////****************** IQuestionComponent ****************************************************////
    public saveAnswer = null;  // Not Implemented

    public getAnswers(): Core.AssessmentAnswer[] {
        if(!isNullOrUndefined(this.answerValue)) {
            const answer: Core.AssessmentAnswer = {
                question: { id: this.question && this.question.id || null },
                text: `${this.answerValue}`
            };

            return [answer];
        }

        return [];
    }

}
